<div class="container-fluid">
  <form #pscForm="ngForm">
    <!-- Header -->
    <div class="row top10">
      <div class="col-xs-12 col-xs-4">
        <div class="row">
          <h4>{{headerText}}</h4>
        </div>
        <div class="row" *ngIf="(permissions.canRead(permissions.ComponentID.PscHrRoutingQueue) || permissions.canRead(permissions.ComponentID.PscAcctReceivalQueue) &&
             (psc.employeeStatusToId == NEW_HIRE || psc.employeeStatusToId == REHIRE))">
          <h4>{{piiText}}</h4>
        </div>
        <div class="row" *ngIf="(permissions.canRead(permissions.ComponentID.PscItReceivalQueue) &&
             (psc.employeeStatusToId == NEW_HIRE || psc.employeeStatusToId == REHIRE))">
          <h4>{{itText}}</h4>
        </div>
      </div>

      <div class="col-xs-12 col-lg-8 vcenter-right">
        <div *ngIf="(displayStatus)">
          <b>Status:&nbsp;</b> <span>{{pscValidStatus}} &nbsp;&nbsp;</span>
        </div>

        <div class="btn-group" role="group" aria-label="...">
          <button type="button" *ngIf="pscForm.dirty" class="btn btn-default btn-sm" (click)="cancelPsc()">
            <i class="fas fa-ban"></i>&nbsp;Cancel
          </button>

          <button type="button" class="btn btn-default btn-sm" *ngIf="(isNewPsc())" [disabled]="(!pscForm.valid)"
            (click)="updatePscRoute('Create PSC')">
            <i class="fas fa-plus"></i>&nbsp;Create PSC
          </button>

          <button type="button" class="btn btn-default btn-sm" *ngIf="(pscForm.dirty && canSave())"
            [disabled]="(!pscForm.valid)" (click)="updatePscRoute('Save PSC')">
            <i class="fas fa-save"></i>&nbsp;Save
          </button>

          <button type="button" class="btn btn-default btn-sm" *ngIf="(!psc.submitted && canAudit())"
            [disabled]="(!pscForm.valid)" (click)="updatePscRoute('HR audit')">
            <i class="fas fa-check"></i>&nbsp;HR Audit
          </button>

          <button type="button" class="btn btn-default btn-sm"
            *ngIf="(routedFrom=='pscWsLeadReview' && psc.submitted && canWSLeadReview())" id="LeadReviewed"
            (click)="updatePscRoute(routedFrom)">
            <i class="fas fa-thumbs-up"></i>&nbsp;Lead Reviewed
          </button>

          <!--Allow the temporary PMM to approve any depatments PSCs-->
          <button type="button" class="btn btn-default btn-sm"
            *ngIf="(routedFrom=='pscDmApproval' && psc.submitted && canDmApprove())" id="DmApproved"
            (click)="updatePscRoute(routedFrom)">
            <i class="fas fa-thumbs-up"></i>&nbsp;DM Approved
          </button>

          <button type="button" class="btn btn-default btn-sm"
            *ngIf="(routedFrom == 'pscHrmApproval' && (canHrmApprove() || canSubmit()))" [disabled]="(!pscForm.valid)"
            (click)="updatePscRoute(routedFrom)">
            <i class="fas fa-thumbs-up"></i>&nbsp;HRM Approved
          </button>

          <button type="button" class="btn btn-default btn-sm"
            *ngIf="(routedFrom == 'pscPmmApproval' && canPmmApprove())" (click)="updatePscRoute(routedFrom)">
            <i class="fas fa-thumbs-up"></i>&nbsp;PMM Approved
          </button>

          <button type="button" class="btn btn-default btn-sm"
            *ngIf="(routedFrom == 'pscAcctReceival' && canAcctRecv())" (click)="updatePscRoute(routedFrom)">
            <i class="fas fa-thumbs-up"></i>&nbsp;Acct Received
          </button>

          <button type="button" class="btn btn-default btn-sm" *ngIf="(routedFrom =='pscItReceival' && canItRecv())"
            (click)="updatePscRoute(routedFrom)">
            <i class="fas fa-thumbs-up"></i>&nbsp;IT Received
          </button>

          <button type="button" class="btn btn-default btn-sm"
            *ngIf="(!(routedFrom=='pscWsLeadReview' || routedFrom == 'pscAcctReceival' || routedFrom =='pscItReceival') && canReject() )"
            (click)="updatePscRoute('Rejected')">
            <i class="fas fa-thumbs-down"></i>&nbsp;Reject PSC
          </button>

          <button type="button" class="btn btn-default btn-sm"
            *ngIf="((routedFrom == 'pscHrmApproval' || routedFrom == 'pscHrRouting') && psc.submitted && canAccept())"
            (click)="updatePscRoute('Accepted')">
            <i class="fas fa-archive"></i>&nbsp;Accept PSC
          </button>

          <button type="button" class="btn btn-default btn-sm" *ngIf="(psc.accepted && canPrint())"
            (click)="updatePscRoute('Print')">
            <i class="fas fa-archive"></i>&nbsp;Print
          </button>

        </div>

      </div>
    </div>

    <hr style="margin-top:2px;margin-bottom:2px" />
    <div class="top10">
      <aims-form [editable]="newPsc && calculateEditable()" [spaceRows]="false">

        <aims-fc>
          <mat-form-field>
            <mat-select panelClass="long-panel" #aimsControl="ngModel" [(ngModel)]="psc.pscTypeId" class="fullWidth"
              name="PSC Type" (selectionChange)="fillEmpData(psc.pscTypeId)" required>
              <mat-option *ngFor="let val of filteredPscTypes" [value]="val.pscTypeId">
                {{ val.pscType}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </aims-fc>

        <aims-fc>
          <mat-form-field>
            <input name="Effective On" matInput #aimsControl="ngModel" [matDatepicker]="picker1"
              [(ngModel)]="psc.effectiveOn" required>
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
          </mat-form-field>
        </aims-fc>
      </aims-form>
    </div>
    <hr *ngIf="psc.submitted || psc.rejected" style="margin-top:2px;margin-bottom:2px" />

    <div class="top10">
      <aims-form *ngIf="psc.submitted || psc.rejected" [editable]="false" [spaceRows]="false">
        <ng-container *ngIf="psc.audited">
          <aims-fc>
            <mat-checkbox #aimsControl="ngModel" name="Audited" [(ngModel)]="psc.audited"></mat-checkbox>
          </aims-fc>
        </ng-container>
        <ng-container *ngIf="psc.submitted">
          <aims-fc>
            <mat-checkbox #aimsControl="ngModel" name="Submitted" [(ngModel)]="psc.submitted"></mat-checkbox>
          </aims-fc>
        </ng-container>
        <ng-container *ngIf="psc.accepted">
          <aims-fc>
            <mat-checkbox #aimsControl="ngModel" name="Accepted" [(ngModel)]="psc.accepted"></mat-checkbox>
          </aims-fc>
        </ng-container>
        <ng-container *ngIf="psc.rejected">
          <aims-fc>
            <aims-fc>
              <mat-checkbox #aimsControl="ngModel" name="Rejected" [(ngModel)]="psc.rejected"></mat-checkbox>
            </aims-fc>
            <aims-fc>
              <mat-form-field>
                <input name="On" matInput #aimsControl="ngModel" [matDatepicker]="picker2" [(ngModel)]="psc.rejectedOn"
                  required />
                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
              </mat-form-field>
            </aims-fc>
            <aims-fc>
              <mat-form-field>
                <input matInput #aimsControl="ngModel" class="fullWidth" type="text" name="By"
                  [(ngModel)]="psc.rejectedBy" />
              </mat-form-field>
            </aims-fc>
          </aims-fc>
        </ng-container>
      </aims-form>
    </div>
    <hr *ngIf="psc.submitted || psc.rejected" style="margin-top:2px;margin-bottom:2px" />

    <div class="top20">
      <aims-form [editable]="false" [cols]="6" [spaceRows]="false">

        <ng-container *ngIf="(calculateRequired('pscWsLeadReview'))">
          <aims-fc [showDescendants]="false">
            <aims-form [cols]="1" [spaceRows]="false">
              <aims-fc [labelColSize]="7" [controlColSize]="5">
                <mat-checkbox #aimsControl="ngModel" name="WSLead Reviewed" [ngModel]="(psc.wsLeadReviewedOn != null)"
                  disabled>
                </mat-checkbox>
              </aims-fc>
              <ng-container *ngIf="psc.wsLeadReviewedOn != null">
                <aims-fc>
                  <div class="col-xs-12 text-center top10">
                    {{'by ' + psc.wsLeadReviewedBy}}<br />
                  </div>
                </aims-fc>
              </ng-container>
            </aims-form>
          </aims-fc>
        </ng-container>

        <ng-container *ngIf="(calculateRequired('pscDmApproval'))">
          <aims-fc [showDescendants]="false">
            <aims-form [cols]="1" [spaceRows]="false">
              <aims-fc [labelColSize]="7" [controlColSize]="5">
                <mat-checkbox #aimsControl="ngModel" name="DM Approved" [ngModel]="(psc.dmApprovedOn != null)" disabled>
                </mat-checkbox>
              </aims-fc>
              <ng-container *ngIf="psc.dmApprovedOn != null">
                <aims-fc>
                  <div class="col-xs-12 text-center top10">
                    {{'by ' + psc.dmApprovedBy}}<br />
                  </div>
                </aims-fc>
              </ng-container>
            </aims-form>
          </aims-fc>
        </ng-container>

        <ng-container *ngIf="(calculateRequired('pscHrmApproval'))">
          <aims-fc [showDescendants]="false">
            <aims-form [cols]="1" [spaceRows]="false">
              <aims-fc [labelColSize]="7" [controlColSize]="5">
                <mat-checkbox #aimsControl="ngModel" name="HRM Approved" [ngModel]="(psc.hrmApprovedOn != null)"
                  disabled>
                </mat-checkbox>
              </aims-fc>
              <ng-container *ngIf="(psc.hrmApprovedOn != null)">
                <aims-fc>
                  <div class="col-xs-12 text-center top10">
                    {{'by ' + psc.hrmApprovedBy}}<br />
                  </div>
                </aims-fc>
              </ng-container>
            </aims-form>
          </aims-fc>
        </ng-container>

        <ng-container *ngIf="(calculateRequired('pscPmmApproval'))">
          <aims-fc [showDescendants]="false">
            <aims-form [cols]="1" [spaceRows]="false">
              <aims-fc [labelColSize]="7" [controlColSize]="5">
                <mat-checkbox #aimsControl="ngModel" name="PMM Approved" [ngModel]="(psc.pmmApprovedOn != null)"
                  disabled>
                </mat-checkbox>
              </aims-fc>
              <ng-container *ngIf="(psc.pmmApprovedOn != null)">
                <aims-fc>
                  <div class="col-xs-12 text-center top10">
                    {{'by ' + psc.pmmApprovedBy}}<br />
                  </div>
                </aims-fc>
              </ng-container>
            </aims-form>
          </aims-fc>
        </ng-container>

        <ng-container *ngIf="(calculateRequired('pscAcctReceival'))">
          <aims-fc [showDescendants]="false">
            <aims-form [cols]="1" [spaceRows]="false">
              <aims-fc [labelColSize]="7" [controlColSize]="5">
                <mat-checkbox #aimsControl="ngModel" name="Acct Received" [ngModel]="(psc.acctReceivedOn != null)"
                  disabled>
                </mat-checkbox>
              </aims-fc>
              <ng-container *ngIf="(psc.acctReceivedOn != null)">
                <aims-fc>
                  <div class="col-xs-12 text-center top10">
                    {{'by ' + psc.acctReceivedBy}}<br />
                  </div>
                </aims-fc>
              </ng-container>
            </aims-form>
          </aims-fc>
        </ng-container>

        <ng-container *ngIf="(calculateRequired('pscItReceival'))">
          <aims-fc [showDescendants]="false">
            <aims-form [cols]="1" [spaceRows]="false">
              <aims-fc [labelColSize]="7" [controlColSize]="5">
                <mat-checkbox #aimsControl="ngModel" name="IT Received" [ngModel]="(psc.itReceivedOn != null)" disabled>
                </mat-checkbox>
              </aims-fc>
              <ng-container *ngIf="(psc.itReceivedOn != null)">
                <aims-fc>
                  <div class="col-xs-12 text-center top10">
                    {{'by ' + psc.itReceivedBy}}<br />
                  </div>
                </aims-fc>
              </ng-container>
            </aims-form>
          </aims-fc>
        </ng-container>

      </aims-form>
    </div>

    <!--PscTypeId 5 "Name Change", NEW HIRE or REHIRE-->
    <div class="top10">
      <aims-form [spaceRows]="false" [cols]="2" [header]="'Name'" [hider]="!(calculateEditable())"
        *ngIf="psc.pscTypeId == NAME_CHANGE || isLogInNameNull || isMiddleNameNull || psc.employeeStatusToId == NEW_HIRE || psc.employeeStatusToId == REHIRE">
        <aims-fc [showDescendants]="false">
          <aims-form [editable]="(calculateEditable())" [cols]="2" [spaceRows]="false">
            <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
              <aims-fc>
                <div class="col-xs-12 hrColHeader top10">
                  {{'From'}}
                </div>
              </aims-fc>
              <aims-fc>
                <div class="col-xs-12 hrColHeader top10">
                  {{'To'}}
                </div>
              </aims-fc>
            </ng-container>

            <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
              <aims-fc>
                <div class="col-xs-5 text-right top10">
                  <b>Last Name:</b>
                </div>
                <div class="col-xs-7 top10">
                  {{psc.lastNameFrom}}
                </div>
              </aims-fc>
            </ng-container>

            <aims-fc [labelColSize]="5" [controlColSize]="7">
              <mat-form-field>
                <input matInput #aimsControl="ngModel" class="fullWidth" type="text" maxlength="50" id="lastNameTo"
                  name="Last Name" [(ngModel)]="psc.lastNameTo" required />
              </mat-form-field>
            </aims-fc>
            <ng-container *ngIf="psc.employeeStatusToId == NEW_HIRE">
              <aims-fc [isSpacer]="true"></aims-fc>
              <aims-fc [isSpacer]="true"></aims-fc>
            </ng-container>

            <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
              <aims-fc>
                <div class="col-xs-5 text-right top10">
                  <b>First Name:</b>
                </div>
                <div class="col-xs-7 top10">
                  {{psc.firstNameFrom}}
                </div>
              </aims-fc>
            </ng-container>
            <aims-fc [labelColSize]="5" [controlColSize]="7">
              <mat-form-field>
                <input matInput #aimsControl="ngModel" class="fullWidth" type="text" maxlength="50" id="firstNameTo"
                  name="First Name" [(ngModel)]="psc.firstNameTo" (change)="validateUserInput($event)" required />
              </mat-form-field>
            </aims-fc>
            <ng-container *ngIf="psc.employeeStatusToId == NEW_HIRE">
              <aims-fc [isSpacer]="true"></aims-fc>
              <aims-fc [isSpacer]="true"></aims-fc>
            </ng-container>

            <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
              <aims-fc>
                <div class="col-xs-5 text-right top10">
                  <b>Middle Name:</b>
                </div>
                <div class="col-xs-7 top10">
                  {{psc.middleNameFrom}}
                </div>
              </aims-fc>
            </ng-container>
            <aims-fc [labelColSize]="5" [controlColSize]="7">
              <mat-form-field>
                <input matInput #aimsControl="ngModel" class="fullWidth" type="text" maxlength="50" id="middleNameTo"
                  name="Middle Name" [(ngModel)]="psc.middleNameTo" (change)="validateUserInput($event)" required />
              </mat-form-field>
            </aims-fc>
            <ng-container *ngIf="psc.employeeStatusToId == NEW_HIRE">
              <aims-fc [isSpacer]="true"></aims-fc>
              <aims-fc [isSpacer]="true"></aims-fc>
            </ng-container>

            <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
              <aims-fc>
                <div class="col-xs-5 text-right top10">
                  <b>Initial:</b>
                </div>
                <div class="col-xs-7 top10">
                  {{psc.miFrom}}
                </div>
              </aims-fc>
            </ng-container>
            <aims-fc [labelColSize]="5" [controlColSize]="7">
              <mat-form-field>
                <input matInput #aimsControl="ngModel" style="width:auto" type="text" maxlength="1" id="miTo"
                  name="Initial" [(ngModel)]="psc.miTo" disabled />
              </mat-form-field>
            </aims-fc>
            <ng-container *ngIf="psc.employeeStatusToId == NEW_HIRE">
              <aims-fc [isSpacer]="true"></aims-fc>
              <aims-fc [isSpacer]="true"></aims-fc>
            </ng-container>

            <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
              <aims-fc>
                <div class="col-xs-5 text-right top10">
                  <b>Alias:</b>
                </div>
                <div class="col-xs-7 top10">
                  {{psc.akaFrom}}
                </div>
              </aims-fc>
            </ng-container>
            <aims-fc [labelColSize]="5" [controlColSize]="7">
              <mat-form-field>
                <input matInput #aimsControl="ngModel" style="width:auto" type="text" id="akaTo" name="Alias"
                  [(ngModel)]="psc.akaTo" (change)="validateUserInput($event)" />
              </mat-form-field>
            </aims-fc>
            <ng-container *ngIf="psc.employeeStatusToId == NEW_HIRE">
              <aims-fc [isSpacer]="true"></aims-fc>
              <aims-fc [isSpacer]="true"></aims-fc>
            </ng-container>

            <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
              <aims-fc>
                <div class="col-xs-5 text-right top10">
                  <b>Login Name:</b>
                </div>
                <div class="col-xs-7 top10">
                  {{psc.loginNameFrom}}
                </div>
              </aims-fc>
            </ng-container>
            <aims-fc [labelColSize]="5" [controlColSize]="7">
              <mat-form-field>
                <input matInput #aimsControl="ngModel" class="fullWidth" type="text" id="loginNameTo" name="Login Name"
                  [ngModel]="psc.loginNameTo" disabled />
              </mat-form-field>
            </aims-fc>

          </aims-form>
        </aims-fc>

        <ng-container *ngIf="psc.pscTypeId == NAME_CHANGE">
          <aims-fc [labelColSize]="6" [controlColSize]="6">
            <div class="top20">
              <mat-checkbox #aimsControl="ngModel" name="Requires a change in marital status ?"
                [(ngModel)]="isMaritalStatusChangeRequired" (change)=handleRequiresMaritalStatusChange() tabindex="-1">
              </mat-checkbox>
            </div>
          </aims-fc>
          <br />
        </ng-container>

      </aims-form>
    </div>

    <!--PscTypeId 18 "Marital Status Change"-->
    <aims-form [spaceRows]="false" [cols]="2" [header]="'Marital Status Change'" [hider]="!(calculateEditable())"
      *ngIf="psc.pscTypeId == MARITAL_STATUS_CHANGE || isMaritalStatusChangeRequired">
      <aims-fc [showDescendants]="false">
        <aims-form [editable]="(calculateEditable())" [cols]="2" [spaceRows]="true">
          <aims-fc>
            <div class="col-xs-12 hrColHeader top10">
              {{'From'}}
            </div>
          </aims-fc>
          <aims-fc>
            <div class="col-xs-12 hrColHeader top10">
              {{'To'}}
            </div>
          </aims-fc>

          <aims-fc>
            <div class="col-xs-5 text-right top10">
              <b>Marital Status:</b>
            </div>
            <div class="col-xs-7 top10">
              {{psc.maritalStatusFrom}}
            </div>
          </aims-fc>
          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <mat-form-field>
              <mat-select #aimsControl="ngModel" [(ngModel)]="psc.maritalStatusToId" class="fullWidth"
                name="Marital Status" required>
                <mat-option *ngFor="let val of maritalStatusValues | async" [value]="val.maritalStatusId">
                  {{ val.maritalStatus}}
                </mat-option>
              </mat-select>
            </mat-form-field>

          </aims-fc>

        </aims-form>
      </aims-fc>

    </aims-form>

    <!--PscTypeId 1 "Employee Status"-->
    <aims-form [spaceRows]="false" [cols]="2" [header]="'Employee Status'" [hider]="!(calculateEditable())"
      *ngIf="psc.pscTypeId == EMPLOYEE_STATUS">
      <aims-fc [showDescendants]="false">
        <aims-form [editable]="calculateEditable()" [cols]="2" [spaceRows]="false">
          <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
            <aims-fc>
              <div class="col-xs-12 hrColHeader top10">
                {{'From'}}
              </div>
            </aims-fc>
            <aims-fc>
              <div class="col-xs-12 hrColHeader top10">
                {{'To'}}
              </div>
            </aims-fc>
          </ng-container>

          <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
            <aims-fc [labelColSize]="5" [controlColSize]="7">
              <mat-checkbox class="top10" #aimsControl="ngModel" name=" Exempt ?" id="exemptFrom"
                [(ngModel)]="psc.exemptFrom" disabled></mat-checkbox>
            </aims-fc>
          </ng-container>
          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <mat-checkbox class="top10" #aimsControl="ngModel" name="Exempt ?" id="exemptTo" [(ngModel)]="psc.exemptTo"
              tabindex="-1" (change)="defaultUnion(psc.exemptTo)"></mat-checkbox>
          </aims-fc>

          <ng-container *ngIf="psc.employeeStatusToId == NEW_HIRE">
            <aims-fc [isSpacer]="true"></aims-fc>
            <aims-fc [isSpacer]="true"></aims-fc>
            <aims-fc [isSpacer]="true"></aims-fc>
          </ng-container>

          <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
            <aims-fc>
              <div class="col-xs-5 text-right top10">
                <b>Employee Status:</b>
              </div>
              <div class="col-xs-7 top10">
                {{psc.employeeStatusFrom}}
              </div>
            </aims-fc>
          </ng-container>
          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <mat-form-field>
              <mat-select panelClass="long-panel" #aimsControl="ngModel" [(ngModel)]="psc.employeeStatusToId"
                class="fullWidth" name="Employee Status" (selectionChange)="handleEmployeeStatusChanged()" required>
                <mat-option *ngFor="let val of allEmployeeStatuses" [value]="val.employeeStatusId">
                  {{ val.employeeStatus}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </aims-fc>
          <ng-container *ngIf="psc.employeeStatusToId == NEW_HIRE">
            <aims-fc [isSpacer]="true"></aims-fc>
            <aims-fc [isSpacer]="true"></aims-fc>
          </ng-container>

          <ng-container *ngIf="decideWhatGetsDisplayed()">
            <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-checkbox #aimsControl="ngModel" name=" Eligible For Rehire ?" id="eligibleForRehireFrom"
                  [(ngModel)]="psc.eligibleForRehireFrom" disabled></mat-checkbox>
              </aims-fc>
            </ng-container>
            <aims-fc [labelColSize]="5" [controlColSize]="7">
              <mat-checkbox #aimsControl="ngModel" name="Eligible For Rehire ?" id="eligibleForRehireTo"
                [(ngModel)]="psc.eligibleForRehireTo" tabindex="-1"></mat-checkbox>
            </aims-fc>
            <ng-container *ngIf="psc.employeeStatusToId == NEW_HIRE">
              <aims-fc [isSpacer]="true"></aims-fc>
              <aims-fc [isSpacer]="true"></aims-fc>
              <aims-fc [isSpacer]="true"></aims-fc>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
            <aims-fc>
              <div class="col-xs-5 text-right top10">
                <b>Employment Type:</b>
              </div>
              <div class="col-xs-7 top10">
                {{psc.employmentTypeFrom}}
              </div>
            </aims-fc>
          </ng-container>
          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <mat-form-field>
              <mat-select #aimsControl="ngModel" [(ngModel)]="psc.employmentTypeToId" class="fullWidth"
                name="Employment Type"
                [required]="(psc.employeeStatusToId == NEW_HIRE || psc.employmentTypeToId == REHIRE)">
                <mat-option *ngFor="let val of allEmploymentTypes" [value]="val.employmentTypeId">
                  {{ val.employmentTypeCode}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </aims-fc>
          <ng-container *ngIf="psc.employeeStatusToId == NEW_HIRE">
            <aims-fc [isSpacer]="true"></aims-fc>
            <aims-fc [isSpacer]="true"></aims-fc>
          </ng-container>

          <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
            <aims-fc>
              <div class="col-xs-5 text-right top10">
                <b>Employment Status:</b>
              </div>
              <div class="col-xs-7 top10">
                {{psc.employmentStatusFrom}}
              </div>
            </aims-fc>
          </ng-container>
          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <mat-form-field>
              <mat-select #aimsControl="ngModel" [(ngModel)]="psc.employmentStatusToId" class="fullWidth"
                name="Employment Status"
                [required]="(psc.employmentStatusToId == NEW_HIRE || psc.employmentStatusToId == REHIRE)">
                <mat-option *ngFor="let val of allEmploymentStatuses" [value]="val.employmentStatusId">
                  {{ val.employmentStatusCode}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </aims-fc>
          <ng-container *ngIf="psc.employeeStatusToId == NEW_HIRE">
            <aims-fc [isSpacer]="true"></aims-fc>
            <aims-fc [isSpacer]="true"></aims-fc>
          </ng-container>

          <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
            <aims-fc>
              <div class="col-xs-5 text-right top10">
                <b>Permanent Site:</b>
              </div>
              <div class="col-xs-7 top10">
                {{psc.permanentSiteCodeFrom}}
              </div>
            </aims-fc>
          </ng-container>
          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <mat-form-field>
              <mat-select #aimsControl="ngModel" [(ngModel)]="psc.permanentSiteCodeToId" class="fullWidth"
                name="Permanent Site"
                [required]="(psc.employeeStatusToId == NEW_HIRE || psc.employmentTypeToId == REHIRE)">
                <mat-option *ngFor="let val of allSites" [value]="val.siteId">
                  {{ val.siteCode}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </aims-fc>
          <ng-container *ngIf="psc.employeeStatusToId == NEW_HIRE">
            <aims-fc [isSpacer]="true"></aims-fc>
            <aims-fc [isSpacer]="true"></aims-fc>
          </ng-container>

          <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
            <aims-fc>
              <div class="col-xs-5 text-right top10">
                <b>Union:</b>
              </div>
              <div class="col-xs-7 top10">
                {{psc.unionAffiliationCodeFrom}}
              </div>
            </aims-fc>
          </ng-container>
          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <mat-form-field>
              <mat-select #aimsControl="ngModel" [(ngModel)]="psc.unionAffiliationCodeToId" class="fullWidth"
                name="Union"
                [required]="(psc.employeeStatusToId == NEW_HIRE || psc.employeeStatusToId == REHIRE || psc.employeeStatusToId == TRANSFER)">
                <mat-option *ngFor="let val of allUnionAffiliations" [value]="val.unionAffiliationId">
                  {{ val.unionAffiliationCode}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </aims-fc>
          <ng-container *ngIf="psc.employeeStatusToId == NEW_HIRE">
            <aims-fc [isSpacer]="true"></aims-fc>
            <aims-fc [isSpacer]="true"></aims-fc>
          </ng-container>

          <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
            <aims-fc>
              <div class="col-xs-5 text-right top10">
                <b>Department:</b>
              </div>
              <div class="col-xs-7 top10">
                {{psc.departmentFrom}}
              </div>
            </aims-fc>
          </ng-container>
          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <mat-form-field>
              <mat-select #aimsControl="ngModel" [(ngModel)]="psc.departmentToId"
                (selectionChange)="filterWorkSection()" class=" fullWidth" name="Department"
                [required]="(psc.employeeStatusToId == NEW_HIRE || psc.employeeStatusToId == REHIRE || psc.employeeStatusToId == TRANSFER)">
                <mat-option *ngFor="let val of filteredDepartments" [value]="val.departmentId">
                  {{ val.department}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </aims-fc>
          <ng-container *ngIf="psc.employeeStatusToId == NEW_HIRE">
            <aims-fc [isSpacer]="true"></aims-fc>
            <aims-fc [isSpacer]="true"></aims-fc>
          </ng-container>

          <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
            <aims-fc>
              <div class="col-xs-5 text-right top10">
                <b>Work Section:</b>
              </div>
              <div class="col-xs-7 top10">
                {{psc.workSectionFrom}}
              </div>
            </aims-fc>
          </ng-container>
          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <mat-form-field>
              <mat-select #aimsControl="ngModel" [(ngModel)]="psc.workSectionToId" (selectionChange)="filterJobTitle()"
                class=" fullWidth" name="Work Section"
                [required]="(psc.employeeStatusToId == NEW_HIRE || psc.employeeStatusToId == REHIRE || psc.employeeStatusToId == TRANSFER)">
                <mat-option *ngFor="let val of filteredWorkSections" [value]="val.workSectionId">
                  {{ val.workSection}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </aims-fc>
          <ng-container *ngIf="psc.employeeStatusToId == NEW_HIRE">
            <aims-fc [isSpacer]="true"></aims-fc>
            <aims-fc [isSpacer]="true"></aims-fc>
          </ng-container>

          <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
            <aims-fc>
              <div class="col-xs-5 text-right top10">
                <b>Job Title:</b>
              </div>
              <div class="col-xs-7 top10">
                {{psc.jobTitleFrom}}
              </div>
            </aims-fc>
          </ng-container>
          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <mat-form-field>
              <mat-select #aimsControl="ngModel" [(ngModel)]="psc.jobTitleToId"
                (selectionChange)="filterJobAssignment()" class=" fullWidth" name="Job Title"
                [required]="(psc.employeeStatusToId == NEW_HIRE || psc.employeeStatusToId == REHIRE || psc.employeeStatusToId == TRANSFER)">
                <mat-option *ngFor="let val of filteredJobTitles" [value]="val.jobTitleId">
                  {{ val.jobTitle}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </aims-fc>
          <ng-container *ngIf="psc.employeeStatusToId == NEW_HIRE">
            <aims-fc [isSpacer]="true"></aims-fc>
            <aims-fc [isSpacer]="true"></aims-fc>
          </ng-container>

          <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
            <aims-fc>
              <div class="col-xs-5 text-right top10">
                <b>Assignment:</b>
              </div>
              <div class="col-xs-7 top10">
                {{psc.jobAssignmentFrom}}
              </div>
            </aims-fc>
          </ng-container>
          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <aims-lookup #aimsControl="ngModel" name="Assignment" id="employeeJobAssignmentLookupTo" class="fullWidth"
              [gridText]="'Select an Assignment'" [values]="filteredJobAssignments"
              [idPropertyName]="'employeeJobAssignmentId'" [displayPropertyName]="'assignmentDescription'"
              [(ngModel)]="psc.jobAssignmentToId" [columnsInGrid]="employeeJobAssignmentLookupColumns"
              [required]="((psc.employeeStatusToId == NEW_HIRE || psc.employeeStatusToId == REHIRE || psc.employeeStatusToId == TRANSFER) && calculateEditable())">
            </aims-lookup>
          </aims-fc>
        </aims-form>
      </aims-fc>

      <aims-fc [showDescendants]="false">
        <aims-form [editable]="calculateEditable()" [cols]="2" [spaceRows]="false">
          <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
            <aims-fc>
              <div class="col-xs-12 hrColHeader top10">
                {{'From'}}
              </div>
            </aims-fc>
            <aims-fc>
              <div class="col-xs-12 hrColHeader top10">
                {{'To'}}
              </div>
            </aims-fc>
          </ng-container>
          <ng-container *ngIf="psc.employeeStatusToId == NEW_HIRE">
            <aims-fc [isSpacer]="true"></aims-fc>
            <aims-fc [isSpacer]="true"></aims-fc>
          </ng-container>

          <ng-container
            *ngIf="psc.employeeStatusToId == NEW_HIRE || psc.employeeStatusToId == REHIRE ||  psc.employeeStatusToId == OTHER || psc.employeeStatusToId == DATA_CORRECTION">
            <ng-container
              *ngIf="psc.employeeStatusToId != NEW_HIRE && empForPsc.unionAffiliationId != NO_REPRESENTATION">
              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <div class="col-xs-5 text-right top10">
                  <b>Dispatch Date:</b>
                </div>
                <div class="col-xs-7 top10">
                  {{psc.dispatchDateFrom | date: 'MM/dd/yyyy'}}
                </div>
              </aims-fc>

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field *ngIf="psc.unionAffiliationCodeToId != NO_REPRESENTATION">
                  <input name="Dispatch Date" matInput #aimsControl="ngModel" [matDatepicker]="picker3"
                    [(ngModel)]="psc.dispatchDateTo" [max]="today">
                  <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                  <mat-datepicker #picker3></mat-datepicker>
                </mat-form-field>
              </aims-fc>
            </ng-container>
            <ng-container *ngIf="psc.employeeStatusToId == NEW_HIRE">
              <aims-fc [isSpacer]="true"></aims-fc>
              <aims-fc [isSpacer]="true"></aims-fc>
            </ng-container>
          </ng-container>

          <ng-container
            *ngIf="psc.employeeStatusToId == NEW_HIRE || psc.employeeStatusToId == REHIRE ||  psc.employeeStatusToId == OTHER || psc.employeeStatusToId == DATA_CORRECTION">
            <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <div class="col-xs-5 text-right top10">
                  <b> Original Date of Hire:</b>
                </div>
                <div class="col-xs-7 top10">
                  {{psc.originalDateOfHireFrom | date: 'MM/dd/yyyy'}}
                </div>
              </aims-fc>
            </ng-container>
            <aims-fc [labelColSize]="5" [controlColSize]="7">
              <mat-form-field>
                <input name="Original Date of Hire" matInput #aimsControl="ngModel" [matDatepicker]="picker4"
                  [(ngModel)]="psc.originalDateOfHireTo" [max]="today" [required]="psc.employeeStatusToId == NEW_HIRE">
                <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
                <mat-datepicker #picker4></mat-datepicker>
              </mat-form-field>
            </aims-fc>
          </ng-container>
          <ng-container *ngIf="psc.employeeStatusToId == NEW_HIRE">
            <aims-fc [isSpacer]="true"></aims-fc>
            <aims-fc [isSpacer]="true"></aims-fc>
          </ng-container>

          <ng-container
            *ngIf="psc.employeeStatusToId == REHIRE ||  psc.employeeStatusToId == OTHER || psc.employeeStatusToId == DATA_CORRECTION || psc.employeeStatusToId == TRANSFER">
            <aims-fc [labelColSize]="5" [controlColSize]="7">
              <div class="col-xs-5 text-right top10">
                <b> Probation Start:</b>
              </div>
              <div class="col-xs-7 top10">
                {{psc.probationStartFrom | date: 'MM/dd/yyyy'}}
              </div>
            </aims-fc>
          </ng-container>
          <ng-container *ngIf="!doesProbationRestart">
            <aims-fc [isSpacer]="true"></aims-fc>
          </ng-container>
          <ng-container
            *ngIf="psc.employeeStatusToId == NEW_HIRE || doesProbationRestart && (psc.employeeStatusToId == REHIRE ||  psc.employeeStatusToId == OTHER || psc.employeeStatusToId == DATA_CORRECTION || psc.employeeStatusToId == TRANSFER)">
            <aims-fc [labelColSize]="5" [controlColSize]="7">
              <mat-form-field>
                <input name="Probation Start" matInput #aimsControl="ngModel" [matDatepicker]="picker5"
                  [(ngModel)]="psc.probationStartTo" [max]="today"
                  [required]="psc.employeeStatusToId == NEW_HIRE || doesProbationRestart">
                <mat-datepicker-toggle matSuffix [for]="picker5"></mat-datepicker-toggle>
                <mat-datepicker #picker5></mat-datepicker>
              </mat-form-field>
            </aims-fc>
          </ng-container>

          <ng-container
            *ngIf="psc.employeeStatusToId == REHIRE ||  psc.employeeStatusToId == OTHER || psc.employeeStatusToId == DATA_CORRECTION || psc.employeeStatusToId == TRANSFER">
            <aims-form [cols]="2">
              <aims-fc [labelColSize]="6" [controlColSize]="6">
                <mat-checkbox #aimsControl="ngModel" name="New Probation Required" [(ngModel)]="doesProbationRestart"
                  tabindex="-1"></mat-checkbox>
              </aims-fc>

              <aims-fc [labelColSize]="6" [controlColSize]="6">
                <mat-checkbox #aimsControl="ngModel" name="Requires a change in pay?" [(ngModel)]="isPayChangeRequired"
                  (change)=handleRequiresPayChange() tabindex="-1"></mat-checkbox>
              </aims-fc>
            </aims-form>
          </ng-container>

        </aims-form>
      </aims-fc>
    </aims-form>
    <ng-container *ngIf="psc.pscTypeId == EMPLOYEE_STATUS">
      <br />
    </ng-container>

    <!--PscTypeId 11 "Recall Rights"-->
    <aims-form [spaceRows]="false" [cols]="2" [header]="'Recall Rights'" [hider]="!(calculateEditable())"
      *ngIf="psc.pscTypeId == RECALL_RIGHTS || psc.pscTypeId == EMPLOYEE_STATUS && (psc.employeeStatusToId == LAYOFF || psc.employeeStatusToId == REHIRE || psc.employeeStatusToId == OTHER || psc.employeeStatusToId == DATA_CORRECTION)">
      <aims-fc [showDescendants]="false">
        <aims-form [editable]="(calculateEditable())" [cols]="2" [spaceRows]="false">
          <aims-fc>
            <div class="col-xs-12 hrColHeader top10">
              {{'From'}}
            </div>
          </aims-fc>
          <aims-fc>
            <div class="col-xs-12 hrColHeader top10">
              {{'To'}}
            </div>
          </aims-fc>

          <aims-fc>
            <div class="col-xs-5 text-right top10">
              <b>Recall Expire Date:</b>
            </div>
            <div class="col-xs-7 top10">
              {{psc.recallExpireDateFrom | date: 'MM/dd/yyyy'}}
            </div>
          </aims-fc>
          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <mat-form-field>
              <input name="Recall Expire Date" matInput #aimsControl="ngModel" [matDatepicker]="picker6"
                [(ngModel)]="psc.recallExpireDateTo" [required]="psc.pscTypeId == RECALL_RIGHTS">
              <mat-datepicker-toggle matSuffix [for]="picker6"></mat-datepicker-toggle>
              <mat-datepicker #picker6></mat-datepicker>
            </mat-form-field>
          </aims-fc>

          <aims-fc>
            <div class="col-xs-5 text-right top10">
              <b>Recall Rights:</b>
            </div>
            <div class="col-xs-7 top10">
              {{psc.recallRightsFrom}}
            </div>
          </aims-fc>
          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <mat-form-field>
              <textarea matInput type="text" #aimsControl="ngModel" name="Recall Rights" maxlength="100"
                [(ngModel)]="psc.recallRightsTo" [required]="psc.recallExpireDateTo != null">
                 </textarea>
            </mat-form-field>
          </aims-fc>
        </aims-form>
      </aims-fc>
    </aims-form>
    <ng-container *ngIf="psc.pscTypeId == RECALL_RIGHTS">
      <br />
    </ng-container>

    <!--PscTypeId 10 "Bridged Date"-->
    <aims-form [spaceRows]="false" [cols]="2" [header]="'Bridged Date'" [hider]="!(calculateEditable())"
      *ngIf="(psc.pscTypeId == BRIDGED_DATE || (psc.employeeStatusToId == REHIRE && isBridgedDateRequired))">
      <aims-fc [showDescendants]="false">
        <aims-form [editable]="(calculateEditable())" [cols]="2" [spaceRows]="false">
          <aims-fc>
            <div class="col-xs-12 hrColHeader top10">
              {{'From'}}
            </div>
          </aims-fc>
          <aims-fc>
            <div class="col-xs-12 hrColHeader top10">
              {{'To'}}
            </div>
          </aims-fc>

          <aims-fc>
            <div class="col-xs-5 text-right top10">
              <b>Bridged Date:</b>
            </div>
            <div class="col-xs-7 top10">
              {{psc.bridgedDateOfHireFrom | date: 'MM/dd/yyyy'}}
            </div>
          </aims-fc>
          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <mat-form-field>
              <input name="Bridged Date" matInput #aimsControl="ngModel" [matDatepicker]="picker7"
                [(ngModel)]="psc.bridgedDateOfHireTo" [required]="psc.pscTypeId == BRIDGED_DATE">
              <mat-datepicker-toggle matSuffix [for]="picker7"></mat-datepicker-toggle>
              <mat-datepicker #picker7></mat-datepicker>
            </mat-form-field>
          </aims-fc>
        </aims-form>
      </aims-fc>
    </aims-form>
    <ng-container *ngIf="psc.pscTypeId == BRIDGED_DATE">
      <br />
    </ng-container>

    <!--PscTypeId 13 "Clearance"-->
    <aims-form [spaceRows]="false" [cols]="2" [header]="'Clearance'" [hider]="!(calculateEditable())" *ngIf="(psc.pscTypeId == CLEARANCE ||
                                         (psc.pscTypeId == EMPLOYEE_STATUS && (psc.employeeStatusToId == NEW_HIRE || psc.employeeStatusToId == REHIRE)) &&
         (permissions.canUpdate(permissions.ComponentID.PscHrmApprovalQueue) ||
          permissions.canUpdate(permissions.ComponentID.PscDmApprovalQueue)))">
      <aims-fc [showDescendants]="false">
        <aims-form [editable]="(calculateEditable())" [cols]="2" [spaceRows]="false">

          <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
            <aims-fc>
              <div class="col-xs-12 hrColHeader top10">
                {{'From'}}
              </div>
            </aims-fc>
            <aims-fc>
              <div class="col-xs-12 hrColHeader top10">
                {{'To'}}
              </div>
            </aims-fc>
          </ng-container>

          <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
            <aims-fc>
              <div class="col-xs-5 text-right top10">
                <b>Clearance Status:</b>
              </div>
              <div class="col-xs-7 top10">
                {{psc.clearanceStatusFrom}}
              </div>
            </aims-fc>
          </ng-container>
          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <mat-form-field>
              <mat-select #aimsControl="ngModel" [(ngModel)]="psc.clearanceStatusToId" class="fullWidth"
                name="Clearance Status" [required]="(calculateEditable())">
                <mat-option *ngFor="let val of clearanceStatusValues | async" [value]="val.clearanceStatusId">
                  {{ val.clearanceStatus}}
                </mat-option>
              </mat-select>
            </mat-form-field>

          </aims-fc>
          <ng-container *ngIf="psc.employeeStatusToId == NEW_HIRE">
            <aims-fc [isSpacer]="true"></aims-fc>
            <aims-fc [isSpacer]="true"></aims-fc>
          </ng-container>


          <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
            <aims-fc>
              <div class="col-xs-5 text-right top10">
                <b>Clearance Status Date:</b>
              </div>
              <div class="col-xs-7 top10">
                {{psc.clearanceDateFrom | date: 'MM/dd/yyyy'}}
              </div>
            </aims-fc>
          </ng-container>
          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <mat-form-field>
              <input name="Clearance Status Date" matInput #aimsControl="ngModel" [matDatepicker]="picker8"
                [(ngModel)]="psc.clearanceDateTo" [required]="(calculateEditable())">
              <mat-datepicker-toggle matSuffix [for]="picker8"></mat-datepicker-toggle>
              <mat-datepicker #picker8></mat-datepicker>
            </mat-form-field>
          </aims-fc>
        </aims-form>
      </aims-fc>
    </aims-form>
    <ng-container *ngIf="psc.pscTypeId == CLEARANCE">
      <br />
    </ng-container>

    <!--PscTypeId 9 "Driver's License"-->
    <aims-form [spaceRows]="false" [cols]="2" [header]="'Driver\'s License'" [hider]="!(calculateEditable())" *ngIf="(psc.pscTypeId == DRIVERS_LICENSE ||
                                         (psc.pscTypeId == EMPLOYEE_STATUS && (psc.employeeStatusToId == NEW_HIRE || psc.employeeStatusToId == REHIRE))  &&
                             (permissions.canUpdate(permissions.ComponentID.PscHrRoutingQueue) ||
                              permissions.canUpdate(permissions.ComponentID.PscHrmApprovalQueue)))">
      <aims-fc [showDescendants]="false">
        <aims-form [editable]="(calculateEditable())" [cols]="2" [spaceRows]="false">

          <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
            <aims-fc>
              <div class="col-xs-12 hrColHeader top10">
                {{'From'}}
              </div>
            </aims-fc>
            <aims-fc>
              <div class="col-xs-12 hrColHeader top10">
                {{'To'}}
              </div>
            </aims-fc>
          </ng-container>

          <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
            <aims-fc>
              <div class="col-xs-5 text-right top10">
                <b>License #:</b>
              </div>
              <div class="col-xs-7 top10">
                {{psc.driversLicenseFrom}}
              </div>
            </aims-fc>
          </ng-container>
          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <mat-form-field>
              <input matInput #aimsControl="ngModel" type="text" name="License #" [(ngModel)]="psc.driversLicenseTo"
                required />
            </mat-form-field>
          </aims-fc>

          <ng-container *ngIf="psc.employeeStatusToId == NEW_HIRE">
            <aims-fc [isSpacer]="true"></aims-fc>
            <aims-fc [isSpacer]="true"></aims-fc>
          </ng-container>

          <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
            <aims-fc>
              <div class="col-xs-5 text-right top10">
                <b>State:</b>
              </div>
              <div class="col-xs-7 top10">
                {{psc.driversLicenseStateFrom}}
              </div>
            </aims-fc>
          </ng-container>
          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <aims-lookup name="State" #aimsControl="ngModel" [gridText]="'Select a State or Territory'"
              [values]="stateOrTerritoryValues | async" [idPropertyName]="'stateOrTerritoryId'"
              [displayPropertyName]="'postalCode'" [(ngModel)]="psc.driversLicenseStateToId"
              [columnsInGrid]="stateLookupColumns" required>
            </aims-lookup>
          </aims-fc>
          <ng-container *ngIf="psc.employeeStatusToId == NEW_HIRE">
            <aims-fc [isSpacer]="true"></aims-fc>
            <aims-fc [isSpacer]="true"></aims-fc>
          </ng-container>

          <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
            <aims-fc>
              <div class="col-xs-5 text-right top10">
                <b>Exp Date:</b>
              </div>
              <div class="col-xs-7 top10">
                {{psc.driversLicenseExpDateFrom | date: 'MM/dd/yyyy'}}
              </div>
            </aims-fc>
          </ng-container>
          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <mat-form-field>
              <input name="Exp Date" matInput #aimsControl="ngModel" [matDatepicker]="picker9"
                [(ngModel)]="psc.driversLicenseExpDateTo" [required]="(calculateEditable())">
              <mat-datepicker-toggle matSuffix [for]="picker9"></mat-datepicker-toggle>
              <mat-datepicker #picker9></mat-datepicker>
            </mat-form-field>
          </aims-fc>
        </aims-form>

      </aims-fc>
    </aims-form>
    <ng-container *ngIf="psc.pscTypeId == DRIVERS_LICENSE">
      <br />
    </ng-container>

    <!--PscTypeId 6 "Contact Info"-->
    <aims-form [spaceRows]="false" [cols]="2" [header]="'Contact Information'" [hider]="!(calculateEditable())" *ngIf="(psc.pscTypeId == CONTACT_INFO ||
                                         (psc.pscTypeId == EMPLOYEE_STATUS && (psc.employeeStatusToId == NEW_HIRE || psc.employeeStatusToId == REHIRE))  &&
                             (permissions.canUpdate(permissions.ComponentID.PscHrRoutingQueue) ||
                              permissions.canUpdate(permissions.ComponentID.PscHrmApprovalQueue)))">
      <aims-fc [showDescendants]="false">
        <aims-form [editable]="calculateEditable()" [cols]="2" [spaceRows]="false">
          <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
            <aims-fc>
              <div class="col-xs-12 hrColHeader top10">
                {{'From'}}
              </div>
            </aims-fc>
            <aims-fc>
              <div class="col-xs-12 hrColHeader top10">
                {{'To'}}
              </div>
            </aims-fc>
          </ng-container>

          <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
            <aims-fc>
              <div class="col-xs-5 text-right top10">
                <b>Primary #:</b>
              </div>
              <div class="col-xs-7 top10">
                {{psc.primaryPhoneFrom}}
              </div>
            </aims-fc>
          </ng-container>
          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <mat-form-field>
              <input matInput name="Primary #" #aimsControl="ngModel" [mask]="'000-000-0000'"  [dropSpecialCharacters]="false"
                [(ngModel)]="psc.primaryPhoneTo" required />
            </mat-form-field>
          </aims-fc>
          <ng-container *ngIf="psc.employeeStatusToId == NEW_HIRE">
            <aims-fc [isSpacer]="true"></aims-fc>
            <aims-fc [isSpacer]="true"></aims-fc>
          </ng-container>

          <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
            <aims-fc>
              <div class="col-xs-5 text-right top10">
                <b>Alternate #:</b>
              </div>
              <div class="col-xs-7 top10">
                {{psc.alternatePhoneFrom}}
              </div>
            </aims-fc>
          </ng-container>
          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <mat-form-field>
              <input matInput name="Alternate #" #aimsControl="ngModel" [mask]="'000-000-0000'" [dropSpecialCharacters]="false"
                [(ngModel)]="psc.alternatePhoneTo" />
            </mat-form-field>
            <button type="button" class="btn btn-default btn-sm"
              *ngIf="calculateEditable() && routedFrom == 'selfServicePsc' || psc.employeeStatusToId == REHIRE || psc.pscTypeId == CONTACT_INFO"
              (click)="zeroOutAlternateNumber('Contact')">
              Click to remove current Alt #
            </button>
          </aims-fc>

        </aims-form>
      </aims-fc>
    </aims-form>
    <ng-container *ngIf="psc.pscTypeId == CONTACT_INFO">
      <br />
    </ng-container>

    <!--PscTypeId 7 "Emergency Contact Info"-->
    <aims-form [spaceRows]="false" [cols]="2" [header]="'Emergency Contact Information'"
      [hider]="!(calculateEditable())" *ngIf="(psc.pscTypeId == EMERG_CONTACT_INFO ||
                                         (psc.pscTypeId == EMPLOYEE_STATUS && (psc.employeeStatusToId == NEW_HIRE || psc.employeeStatusToId == REHIRE))  &&
                             (permissions.canUpdate(permissions.ComponentID.PscHrRoutingQueue) ||
                              permissions.canUpdate(permissions.ComponentID.PscHrmApprovalQueue)))">
      <aims-fc [showDescendants]="false">
        <aims-form [editable]="calculateEditable()" [cols]="2" [spaceRows]="false">
          <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
            <aims-fc>
              <div class="col-xs-12 hrColHeader top10">
                {{'From'}}
              </div>
            </aims-fc>
            <aims-fc>
              <div class="col-xs-12 hrColHeader top10">
                {{'To'}}
              </div>
            </aims-fc>
          </ng-container>

          <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
            <aims-fc>
              <div class="col-xs-5 text-right top10">
                <b>Last Name:</b>
              </div>
              <div class="col-xs-7 top10">
                {{psc.emergencyContactLastNameFrom}}
              </div>
            </aims-fc>
          </ng-container>
          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <mat-form-field>
              <input matInput #aimsControl="ngModel" class="fullWidth" type="text" maxlength="50" name=" Last Name"
                [(ngModel)]="psc.emergencyContactLastNameTo" (change)="validateUserInput($event)" required />
            </mat-form-field>
          </aims-fc>
          <ng-container *ngIf="psc.employeeStatusToId == NEW_HIRE">
            <aims-fc [isSpacer]="true"></aims-fc>
            <aims-fc [isSpacer]="true"></aims-fc>
          </ng-container>

          <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
            <aims-fc>
              <div class="col-xs-5 text-right top10">
                <b>First Name:</b>
              </div>
              <div class="col-xs-7 top10">
                {{psc.emergencyContactFirstNameFrom}}
              </div>
            </aims-fc>
          </ng-container>
          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <mat-form-field>
              <input matInput #aimsControl="ngModel" class="fullWidth" type="text" maxlength="50" name=" First Name"
                [(ngModel)]="psc.emergencyContactFirstNameTo" (change)="validateUserInput($event)" required />
            </mat-form-field>
          </aims-fc>
          <ng-container *ngIf="psc.employeeStatusToId == NEW_HIRE">
            <aims-fc [isSpacer]="true"></aims-fc>
            <aims-fc [isSpacer]="true"></aims-fc>
          </ng-container>

          <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
            <aims-fc>
              <div class="col-xs-5 text-right top10">
                <b>Primary #:</b>
              </div>
              <div class="col-xs-7 top10">
                {{psc.emergencyContactPrimaryPhoneFrom}}
              </div>
            </aims-fc>
          </ng-container>
          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <mat-form-field>
              <input matInput name=" Primary #" #aimsControl="ngModel" [mask]="'000-000-0000'" [dropSpecialCharacters]="false"
                [(ngModel)]="psc.emergencyContactPrimaryPhoneTo" required />
            </mat-form-field>
          </aims-fc>
          <ng-container *ngIf="psc.employeeStatusToId == NEW_HIRE">
            <aims-fc [isSpacer]="true"></aims-fc>
            <aims-fc [isSpacer]="true"></aims-fc>
          </ng-container>

          <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
            <aims-fc>
              <div class="col-xs-5 text-right top10">
                <b>Alternate #:</b>
              </div>
              <div class="col-xs-7 top10">
                {{psc.emergencyContactAlternatePhoneFrom}}
              </div>
            </aims-fc>
          </ng-container>
          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <mat-form-field>
              <input matInput name=" Alternate #" #aimsControl="ngModel" [mask]="'000-000-0000'" [dropSpecialCharacters]="false"
                [(ngModel)]="psc.emergencyContactAlternatePhoneTo" />
            </mat-form-field>
            <button type="button" class="btn btn-default btn-sm"
              *ngIf="calculateEditable() && routedFrom == 'selfServicePsc' || psc.employeeStatusToId == REHIRE || psc.pscTypeId == EMERG_CONTACT_INFO"
              (click)="zeroOutAlternateNumber('EmergContact')">
              Click to remove current Alt #
            </button>
          </aims-fc>

        </aims-form>
      </aims-fc>
    </aims-form>
    <ng-container *ngIf="psc.pscTypeId == EMERG_CONTACT_INFO">
      <br />
    </ng-container>


    <!--PscTypeId 8 "Address"-->
    <aims-form [spaceRows]="false" [cols]="2" [header]="'Address Information'" [hider]="!(calculateEditable())" *ngIf="(psc.pscTypeId == ADDRESS ||
                                         (psc.pscTypeId == EMPLOYEE_STATUS && (psc.employeeStatusToId == NEW_HIRE || psc.employeeStatusToId == REHIRE))  &&
                             (permissions.canUpdate(permissions.ComponentID.PscHrRoutingQueue) ||
                              permissions.canUpdate(permissions.ComponentID.PscHrmApprovalQueue) ||
                              permissions.canUpdate(permissions.ComponentID.PscAcctReceivalQueue) ||
                             (routedFrom =='selfServicePsc' && permissions.canUpdate(permissions.ComponentID.PSC))))">
      <aims-fc [showDescendants]="false">
        <aims-form [editable]="calculateEditable()" [cols]="2" [spaceRows]="false">
          <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
            <aims-fc>
              <div class="col-xs-12 hrColHeader top10">
                {{'Home From'}}
              </div>
            </aims-fc>
          </ng-container>
          <aims-fc>
            <div class="col-xs-12 hrColHeader top10">
              {{'Home To'}}
            </div>
          </aims-fc>

          <ng-container *ngIf="psc.employeeStatusToId == NEW_HIRE">
            <aims-fc [isSpacer]="true"></aims-fc>
            <aims-fc [isSpacer]="true"></aims-fc>
            <aims-fc [isSpacer]="true"></aims-fc>
          </ng-container>

          <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
            <aims-fc>
              <div class="col-xs-5 text-right top10">
                <b>Street Address:</b>
              </div>
              <div class="col-xs-7 top10">
                {{psc.homeAddressFrom}}
              </div>
            </aims-fc>
          </ng-container>

          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <mat-form-field>
              <input matInput #aimsControl="ngModel" class="fullWidth" type="text" maxlength="100" name="Street Address"
                [(ngModel)]="psc.homeAddressTo" (change)="handleHomeStreetChanged()"
                [required]="psc.homeCityTo != null" />
            </mat-form-field>
          </aims-fc>

          <ng-container *ngIf="psc.employeeStatusToId == NEW_HIRE">
            <aims-fc [isSpacer]="true"></aims-fc>
            <aims-fc [isSpacer]="true"></aims-fc>
          </ng-container>

          <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
            <aims-fc>
              <div class="col-xs-5 text-right top10">
                <b>City:</b>
              </div>
              <div class="col-xs-7 top10">
                {{psc.homeCityFrom}}
              </div>
            </aims-fc>
          </ng-container>

          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <mat-form-field>
              <input matInput #aimsControl="ngModel" class="fullWidth" type="text" name="City" maxlength="50"
                [(ngModel)]="psc.homeCityTo" (change)="handleHomeCityChanged()"
                [required]="psc.homeAddressTo != null" />
            </mat-form-field>
          </aims-fc>

          <ng-container *ngIf="psc.employeeStatusToId == NEW_HIRE">
            <aims-fc [isSpacer]="true"></aims-fc>
            <aims-fc [isSpacer]="true"></aims-fc>
          </ng-container>

          <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
            <aims-fc>
              <div class="col-xs-5 text-right top10">
                <b>State:</b>
              </div>
              <div class="col-xs-7 top10">
                {{psc.homeStateFrom}}
              </div>
            </aims-fc>
          </ng-container>

          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <aims-lookup #aimsControl="ngModel" class="fullWidth" name=" State"
              [gridText]="'Select a State or Territory'" [values]="stateOrTerritoryValues | async"
              [idPropertyName]="'stateOrTerritoryId'" [displayPropertyName]="'postalCode'"
              [(ngModel)]="psc.homeStateToId" [columnsInGrid]="stateLookupColumns"
              (valueChange)="handleHomeStateChanged($event)"
              [required]="(psc.homeAddressTo != null && (calculateEditable()))">
            </aims-lookup>
          </aims-fc>

          <ng-container *ngIf="psc.employeeStatusToId == NEW_HIRE">
            <aims-fc [isSpacer]="true"></aims-fc>
            <aims-fc [isSpacer]="true"></aims-fc>
          </ng-container>

          <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
            <aims-fc>
              <div class="col-xs-5 text-right top10">
                <b>Zip:</b>
              </div>
              <div class="col-xs-7 top10">
                {{psc.homeZipFrom}}
              </div>
            </aims-fc>
          </ng-container>


          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <mat-form-field>
              <input matInput mask="00009-9999" [dropSpecialCharacters]="false"  #aimsControl="ngModel" class="fullWidth" type="text" name="Zip"
                [(ngModel)]="psc.homeZipTo" (change)="handleHomeZipChanged()" [required]="psc.homeAddressTo != null" />
            </mat-form-field>
          </aims-fc>
          <ng-container *ngIf="psc.employeeStatusToId == NEW_HIRE">
            <aims-fc [isSpacer]="true"></aims-fc>
            <aims-fc [isSpacer]="true"></aims-fc>
          </ng-container>

          <ng-container *ngIf="(calculateEditable())">
            <aims-fc [isSpacer]="true"></aims-fc>
            <aims-fc [labelColSize]="5" [controlColSize]="7">
              <mat-checkbox #aimsControl="ngModel" name="Mailing address the same?" [(ngModel)]="isSameAddress"
                (change)="handleSameAddressChecked()"></mat-checkbox>
            </aims-fc>
          </ng-container>

        </aims-form>
      </aims-fc>

      <aims-fc [showDescendants]="false">
        <aims-form [editable]="calculateEditable()" [cols]="2" [spaceRows]="false">

          <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
            <aims-fc>
              <div class="col-xs-12 hrColHeader top10">
                {{'Mailing From'}}
              </div>
            </aims-fc>
          </ng-container>

          <aims-fc>
            <div class="col-xs-12 hrColHeader top10">
              {{'Mailing To'}}
            </div>
          </aims-fc>

          <ng-container *ngIf="psc.employeeStatusToId == NEW_HIRE">
            <aims-fc [isSpacer]="true"></aims-fc>
            <aims-fc [isSpacer]="true"></aims-fc>
            <aims-fc [isSpacer]="true"></aims-fc>
          </ng-container>

          <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
            <aims-fc>
              <div class="col-xs-5 text-right top10">
                <b>Street Address:</b>
              </div>
              <div class="col-xs-7 top10">
                {{psc.mailingAddressFrom}}
              </div>
            </aims-fc>
          </ng-container>

          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <mat-form-field>
              <input matInput #aimsControl="ngModel" class="fullWidth" name=" Street Address" type="text"
                maxlength="100" [(ngModel)]="psc.mailingAddressTo" [required]="(psc.mailingCityTo != null)" />
            </mat-form-field>
          </aims-fc>

          <ng-container *ngIf="psc.employeeStatusToId == NEW_HIRE">
            <aims-fc [isSpacer]="true"></aims-fc>
            <aims-fc [isSpacer]="true"></aims-fc>
          </ng-container>

          <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
            <aims-fc>
              <div class="col-xs-5 text-right top10">
                <b>City:</b>
              </div>
              <div class="col-xs-7 top10">
                {{psc.mailingCityFrom}}
              </div>
            </aims-fc>
          </ng-container>

          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <mat-form-field>
              <input matInput #aimsControl="ngModel" class="fullWidth" name=" City" type="text" maxlength="50"
                [(ngModel)]="psc.mailingCityTo" [required]="(psc.mailingAddressTo != null )" />
            </mat-form-field>
          </aims-fc>

          <ng-container *ngIf="psc.employeeStatusToId == NEW_HIRE">
            <aims-fc [isSpacer]="true"></aims-fc>
            <aims-fc [isSpacer]="true"></aims-fc>
          </ng-container>

          <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
            <aims-fc>
              <div class="col-xs-5 text-right top10">
                <b>State:</b>
              </div>
              <div class="col-xs-7 top10">
                {{psc.mailingStateFrom}}
              </div>
            </aims-fc>
          </ng-container>

          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <aims-lookup #aimsControl="ngModel" class="fullWidth" name="  State"
              [gridText]="'Select a State or Territory'" [values]="stateOrTerritoryValues | async"
              [idPropertyName]="'stateOrTerritoryId'" [displayPropertyName]="'postalCode'"
              [(ngModel)]="psc.mailingStateToId" [columnsInGrid]="stateLookupColumns"
              [required]="(psc.mailingAddressTo != null || psc.employeeStatusToId == NEW_HIRE)">
            </aims-lookup>
          </aims-fc>

          <ng-container *ngIf="psc.employeeStatusToId == NEW_HIRE">
            <aims-fc [isSpacer]="true"></aims-fc>
            <aims-fc [isSpacer]="true"></aims-fc>
          </ng-container>

          <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
            <aims-fc>
              <div class="col-xs-5 text-right top10">
                <b>Zip:</b>
              </div>
              <div class="col-xs-7 top10">
                {{psc.mailingZipFrom}}
              </div>
            </aims-fc>
          </ng-container>

          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <mat-form-field>
              <input matInput mask="00009-9999" [dropSpecialCharacters]="false" #aimsControl="ngModel" class="fullWidth" type="text" name=" Zip"
                [(ngModel)]="psc.mailingZipTo" [required]="(psc.mailingAddressTo != null)" />
            </mat-form-field>
          </aims-fc>

        </aims-form>
      </aims-fc>
    </aims-form>
    <ng-container *ngIf="psc.pscTypeId == ADDRESS">
      <br />
    </ng-container>


    <!--PscTypeId 12 "Assignments"-->
    <aims-form [spaceRows]="false" [cols]="2" [header]="'Assignment'" [hider]="!(calculateEditable())"
      *ngIf="(psc.pscTypeId == ASSIGNMENT)">
      <aims-fc [showDescendants]="false">
        <aims-form [editable]="calculateEditable()" [cols]="2" [spaceRows]="false">
          <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
            <aims-fc>
              <div class="col-xs-12 hrColHeader top10">
                {{'From'}}
              </div>
            </aims-fc>
            <aims-fc>
              <div class="col-xs-12 hrColHeader top10">
                {{'To'}}
              </div>
            </aims-fc>
          </ng-container>
          <ng-container>
            <aims-fc [isSpacer]="true"></aims-fc>
            <aims-fc [isSpacer]="true"></aims-fc>
          </ng-container>

          <ng-container>
            <aims-fc>
              <div class="col-xs-5 text-right top20">
                <b>Job Title:</b>
              </div>
              <div class="col-xs-7 top20">
                {{psc.jobTitleFrom}}
              </div>
            </aims-fc>
          </ng-container>

          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <mat-form-field>
              <mat-select panelClass="long-panel" #aimsControl="ngModel" [(ngModel)]="psc.jobTitleToId"
                class="fullWidth" name="Job Title" (selectionChange)="filterJobAssignment()"
                [required]="(calculateEditable())">
                <mat-option *ngFor="let val of allJobTitles" [value]="val.jobTitleId">
                  {{ val.jobTitle}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </aims-fc>
          <ng-container>
            <aims-fc [isSpacer]="true"></aims-fc>
            <aims-fc [isSpacer]="true"></aims-fc>
          </ng-container>

          <ng-container>
            <aims-fc>
              <div class="col-xs-5 text-right top20">
                <b>Assignment:</b>
              </div>
              <div class="col-xs-7 top20">
                {{psc.jobAssignmentFrom}}
              </div>
            </aims-fc>
          </ng-container>
          <aims-fc [labelColSize]="5" [controlColSize]="7">
                <aims-lookup #aimsControl="ngModel"
                  name="Assignment"
                  [gridText]="'Select an Assignment'"
                  [values]="filteredJobAssignments"
                  [popupValues]="filteredJobAssignments"
                  [displayPropertyName]="'assignmentDescription'"
                  [idPropertyName]="'employeeJobAssignmentId'"
                  [(ngModel)]="psc.jobAssignmentToId"
                  [columnsInGrid]="employeeJobAssignmentLookupColumns"
                  class="fullWidth"
                  id="employeeJobAssignmentLookup"
                  required>
                </aims-lookup>
          </aims-fc>
          <ng-container *ngIf="psc.employeeStatusToId == NEW_HIRE">
            <aims-fc [isSpacer]="true"></aims-fc>
            <aims-fc [isSpacer]="true"></aims-fc>
          </ng-container>

        </aims-form>
      </aims-fc>
    <ng-container *ngIf="psc.pscTypeId == ASSIGNMENT">

      <aims-form [cols]="2">

        <aims-fc [labelColSize]="6" [controlColSize]="6">
          <mat-checkbox #aimsControl="ngModel" name="Requires a change in pay?" [(ngModel)]="isPayChangeRequired"
            (change)=handleRequiresPayChange() tabindex="-1"></mat-checkbox>
        </aims-fc>
      </aims-form>

    </ng-container>
    </aims-form>



    <!--PscTypeId 2 "Pay"-->
    <aims-form [spaceRows]="false" [cols]="2" [header]="'Pay'" [hider]="!(calculateEditable())" *ngIf="(psc.pscTypeId == PAY || psc.pscTypeId == FISCAL_PAY_CHANGE || isPayChangeRequired || (psc.pscTypeId == EMPLOYEE_STATUS && psc.employeeStatusToId == NEW_HIRE) &&
         (permissions.canUpdate(permissions.ComponentID.PscHrRoutingQueue) ||
          permissions.canUpdate(permissions.ComponentID.PscHrmApprovalQueue) ||
          permissions.canUpdate(permissions.ComponentID.PscPmmApprovalQueue) ||
          permissions.canUpdate(permissions.ComponentID.PscAcctReceivalQueue)))">
      <aims-fc [showDescendants]="false">
        <aims-form [editable]="(calculateEditable())" [cols]="2" [spaceRows]="false">
          <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
            <aims-fc>
              <div class="col-xs-12 hrColHeader top10">
                {{'From'}}
              </div>
            </aims-fc>
            <aims-fc>
              <div class="col-xs-12 hrColHeader top10">
                {{'To'}}
              </div>
            </aims-fc>
          </ng-container>

          <ng-container *ngIf="(!empForPsc.exempt && empForPsc.unionAffiliationId != NO_REPRESENTATION)">
            <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE && !psc.submitted">
              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <aims-lookup #aimsControl="ngModel" class="fullWidth" name="Previous Hourly Rate"
                  [gridText]="'Select a Hourly Rate'" [values]="filteredFromFyPayRates" [idPropertyName]="'fyPayRateId'"
                  [displayPropertyName]="'payRate'" [(ngModel)]="psc.unionHourlyRateFromId"
                  (valueChange)=handleUnionHourlyRateFromChg($event) [columnsInGrid]="fyPayLookupColumns"
                  [required]="(psc.pscTypeId == PAY || psc.pscTypeId == FISCAL_PAY_CHANGE || isPayChangeRequired)">
                </aims-lookup>
              </aims-fc>
            </ng-container>
            <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE && psc.submitted">
              <aims-fc>
                <div class="col-xs-5 text-right top10">
                  <b>Hourly Rate:</b>
                </div>
                <div class="col-xs-7 top10">
                  {{psc.hourlyRateFrom | currency}}
                </div>
              </aims-fc>
            </ng-container>

            <ng-container *ngIf="!psc.submitted">
              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <aims-lookup #aimsControl="ngModel" class="fullWidth" name="New Hourly Rate"
                  [gridText]="'Select a Hourly Rate'" [values]="filteredToFyPayRates" [idPropertyName]="'fyPayRateId'"
                  [displayPropertyName]="'payRate'" [(ngModel)]="psc.unionHourlyRateToId"
                  (valueChange)=handleUnionHourlyRateToChg($event) [columnsInGrid]="fyPayLookupColumns"
                  [required]="(psc.pscTypeId == PAY || psc.pscTypeId == FISCAL_PAY_CHANGE || isPayChangeRequired || (psc.pscTypeId == EMPLOYEE_STATUS && psc.employeeStatusToId == NEW_HIRE))">
                </aims-lookup>
              </aims-fc>
            </ng-container>
            <ng-container *ngIf="psc.submitted">
              <aims-fc>
                <div class="col-xs-5 text-right top10">
                  <b>Hourly Rate:</b>
                </div>
                <div class="col-xs-7 top10">
                  {{psc.hourlyRateTo | currency }}
                </div>
              </aims-fc>
            </ng-container>


            <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
              <aims-fc>
                <div class="col-xs-5 text-right top20">
                  <b>Overtime Rate:</b>
                </div>
                <div class="col-xs-7 top20">
                  {{psc.overTimeRateFrom | currency}}
                </div>
              </aims-fc>
            </ng-container>
            <aims-fc>
              <div class="col-xs-5 text-right top20">
                <b>Overtime Rate:</b>
              </div>
              <div class="col-xs-7 top20">
                {{psc.overTimeRateTo | currency}}
              </div>
            </aims-fc>
          </ng-container>

          <ng-container *ngIf="(!empForPsc.exempt && empForPsc.unionAffiliationId == NO_REPRESENTATION)">
            <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <aims-numeric [numericType]="AIMS_NUMERIC_TYPES.CURRENCY" #aimsControl="ngModel" name="Previous Hourly Rate"
                  [(ngModel)]="psc.hourlyRateFrom" (change)="handleHourlyRateFromChg(psc.hourlyRateFrom)"
                  [required]="(psc.pscTypeId == PAY  || psc.pscTypeId == FISCAL_PAY_CHANGE || isPayChangeRequired)">
                </aims-numeric>
              </aims-fc>
            </ng-container>
            <aims-fc [labelColSize]="5" [controlColSize]="7">
              <aims-numeric [numericType]="AIMS_NUMERIC_TYPES.CURRENCY" #aimsControl="ngModel" name="New Hourly Rate"
                [(ngModel)]="psc.hourlyRateTo" (change)="handleHourlyRateToChg(psc.hourlyRateTo)"
                [required]="(psc.pscTypeId == PAY || psc.pscTypeId == FISCAL_PAY_CHANGE || isPayChangeRequired || (psc.pscTypeId == EMPLOYEE_STATUS && psc.employeeStatusToId == NEW_HIRE))">
              </aims-numeric>
            </aims-fc>
            <ng-container *ngIf="psc.employeeStatusToId == NEW_HIRE">
              <aims-fc [isSpacer]="true"></aims-fc>
              <aims-fc [isSpacer]="true"></aims-fc>
            </ng-container>

            <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
              <aims-fc>
                <div class="col-xs-5 text-right top10">
                  <b>Overtime Rate:</b>
                </div>
                <div class="col-xs-7 top10">
                  {{psc.overTimeRateFrom | currency}}
                </div>
              </aims-fc>
            </ng-container>
            <aims-fc>
              <div class="col-xs-5 text-right top10">
                <b>Overtime Rate:</b>
              </div>
              <div class="col-xs-7 top10">
                {{psc.overTimeRateTo | currency}}
              </div>
            </aims-fc>

          </ng-container>

          <ng-container *ngIf="empForPsc.exempt">
            <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <aims-numeric [numericType]="AIMS_NUMERIC_TYPES.CURRENCY" #aimsControl="ngModel" name=" Salary"
                  [(ngModel)]="psc.salaryFrom" (change)="handleSalaryFromChg(psc.salaryFrom)"
                  [required]="(psc.pscTypeId == PAY || psc.pscTypeId == FISCAL_PAY_CHANGE || isPayChangeRequired)">
                </aims-numeric>
              </aims-fc>
            </ng-container>
            <aims-fc [labelColSize]="5" [controlColSize]="7">
              <aims-numeric [numericType]="AIMS_NUMERIC_TYPES.CURRENCY" #aimsControl="ngModel" name="   Salary"
                [(ngModel)]="psc.salaryTo" (change)="handleSalaryToChg(psc.salaryTo)"
                [required]="(psc.pscTypeId == PAY || psc.pscTypeId == FISCAL_PAY_CHANGE || isPayChangeRequired || (psc.pscTypeId == EMPLOYEE_STATUS && psc.employeeStatusToId == NEW_HIRE))">
              </aims-numeric>
            </aims-fc>
            <ng-container *ngIf="psc.employeeStatusToId == NEW_HIRE">
              <aims-fc [isSpacer]="true"></aims-fc>
              <aims-fc [isSpacer]="true"></aims-fc>
            </ng-container>
            <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
              <aims-fc>
                <div class="col-xs-5 text-right top10">
                  <b>Bi-weekly Rate:</b>
                </div>
                <div class="col-xs-7 top10">
                  {{psc.biWeeklyRateFrom | currency}}
                </div>
              </aims-fc>
            </ng-container>
            <aims-fc>
              <div class="col-xs-5 text-right top10">
                <b>Bi-weekly Rate:</b>
              </div>
              <div class="col-xs-7 top10">
                {{psc.biWeeklyRateTo | currency}}
              </div>
            </aims-fc>

          </ng-container>


        </aims-form>
      </aims-fc>
    </aims-form>
    <ng-container *ngIf="psc.pscTypeId == PAY">
      <br />
    </ng-container>


    <!--PscTypeId 3 "Probation"-->
    <aims-form [spaceRows]="false" [cols]="2" [header]="'Probationary Completion'" [hider]="!(calculateEditable())"
      *ngIf="(psc.pscTypeId == PROBATION )">
      <aims-fc [showDescendants]="false">
        <aims-form [editable]="(calculateEditable())" [cols]="2" [spaceRows]="false">
          <aims-fc>
            <div class="col-xs-12 hrColHeader top10">
              {{'From'}}
            </div>
          </aims-fc>
          <aims-fc>
            <div class="col-xs-12 hrColHeader top10">
              {{'To'}}
            </div>
          </aims-fc>

          <aims-fc>
            <div class="col-xs-5 text-right top10">
              <b>Probation Start:</b>
            </div>
            <div class="col-xs-7 top10">
              {{psc.probationaryCompletionDateFrom | date: 'MM/dd/yyyy'}}
            </div>
          </aims-fc>
          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <mat-form-field>
              <input name="Probation Completion" matInput #aimsControl="ngModel" [matDatepicker]="picker10"
                [(ngModel)]="psc.probationaryCompletionDateTo" [required]="psc.pscTypeId == PROBATION">
              <mat-datepicker-toggle matSuffix [for]="picker10"></mat-datepicker-toggle>
              <mat-datepicker #picker10></mat-datepicker>
            </mat-form-field>
          </aims-fc>
        </aims-form>
        <ng-container *ngIf="psc.pscTypeId == PROBATION">
          <br />
        </ng-container>
      </aims-fc>
    </aims-form>


    <!--PscTypeId 4 "Occ"-->
    <ng-container *ngIf="(empForPsc.unionAffiliationId != NO_REPRESENTATION &&
         (psc.pscTypeId == OCC || psc.pscTypeId == EMPLOYEE_STATUS || psc.pscTypeId == ASSIGNMENT))">
      <aims-form [spaceRows]="false" [cols]="1" [header]="'Occupation Certification Classification (OCC) Information'"
        [hider]="!(calculateEditable())">

        <div id="gridOcc" *ngIf="(empForPsc.unionAffiliationId != NO_REPRESENTATION &&
         (psc.pscTypeId == OCC || psc.pscTypeId == EMPLOYEE_STATUS || psc.pscTypeId == ASSIGNMENT))">
          <div class="row">
            <div class="col-xs-12">

              <aims-common-table id="occ-table" [dataSource]="psc.hrPscOcc" [header]="occHeader"
                [displayedColumns]="occHeaderDisplay" [pageSize]="5" [permissions]="occTablePermissions"
                (rowUpdated)="handlePscOccTableRowUpdate($event)" (rowAdded)="handlePscOccTableRowAdd($event)"
                [addRowInitialObject]="pscOccInitialTableElement">

                <aims-common-table-dynamic-row id="jobTitleToId">
                  <ng-template viewMode let-element>{{ element.jobTitleToId |
                    getText:'jobTitleId':'jobTitle':jobTitleValues |
                    async}}
                  </ng-template>
                  <ng-template editMode let-element let-idx="idx" let-dynamicControl="dynamicControl">
                    <mat-form-field appearance="fill" class="top10 fullWidth">
                      <mat-label></mat-label>
                      <mat-select [formControl]="dynamicControl">
                        <mat-option label=""></mat-option>
                        <mat-option *ngFor="let val of jobTitleValues | async" [value]="val.jobTitleId">
                          {{val.jobTitle}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ng-template>
                </aims-common-table-dynamic-row>

                <aims-common-table-dynamic-row id="occStatusToId">
                  <ng-template viewMode let-element>{{ element.occStatusToId |
                    getText:'occStatusId':'occStatus':occStatusValues |
                    async}}
                  </ng-template>
                  <ng-template editMode let-element let-idx="idx" let-dynamicControl="dynamicControl">
                    <mat-form-field appearance="fill" class="top10 fullWidth">
                      <mat-label></mat-label>
                      <mat-select [formControl]="dynamicControl">
                        <mat-option label=""></mat-option>
                        <mat-option *ngFor="let val of occStatusValues | async" [value]="val.occStatusId">
                          {{val.occStatus}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ng-template>
                </aims-common-table-dynamic-row>

                <aims-common-table-dynamic-row id="employmentTypeToId">
                  <ng-template viewMode let-element>{{ element.employmentTypeToId |
                    getText:'employmentTypeId':'employmentTypeCode':employmentTypeValues |
                    async}}
                  </ng-template>
                  <ng-template editMode let-element let-idx="idx" let-dynamicControl="dynamicControl">
                    <mat-form-field appearance="fill" class="top10 fullWidth">
                      <mat-label></mat-label>
                      <mat-select [formControl]="dynamicControl">
                        <mat-option label=""></mat-option>
                        <mat-option *ngFor="let val of employmentTypeValues | async" [value]="val.employmentTypeId">
                          {{val.employmentTypeCode}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ng-template>
                </aims-common-table-dynamic-row>

                <aims-common-table-dynamic-row id="workSectionToId">
                  <ng-template viewMode let-element>{{ element.workSectionToId |
                    getText:'workSectionId':'workSection':workSectionValues |
                    async}}
                  </ng-template>
                  <ng-template editMode let-element let-idx="idx" let-dynamicControl="dynamicControl">
                    <mat-form-field appearance="fill" class="top10 fullWidth">
                      <mat-label></mat-label>
                      <mat-select [formControl]="dynamicControl">
                        <mat-option label=""></mat-option>
                        <mat-option *ngFor="let val of workSectionValues | async" [value]="val.workSectionId">
                          {{val.workSection}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ng-template>
                </aims-common-table-dynamic-row>
              </aims-common-table>

            </div>

          </div>
        </div>
      </aims-form>
      <hr style="margin-top:2px;margin-bottom:2px" />
    </ng-container>

    <!--PscTypeId 14 "CAC"-->
    <aims-form [spaceRows]="false" [cols]="2" [header]="'Common Access Card (CAC)'" [hider]="!(calculateEditable())"
      *ngIf="(psc.pscTypeId == CAC)">
      <aims-fc [showDescendants]="false">
        <aims-form [editable]="(calculateEditable())" [cols]="2" [spaceRows]="false">
          <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
            <aims-fc>
              <div class="col-xs-12 hrColHeader top10">
                {{'From'}}
              </div>
            </aims-fc>
            <aims-fc>
              <div class="col-xs-12 hrColHeader top10">
                {{'To'}}
              </div>
            </aims-fc>
          </ng-container>

          <ng-container *ngIf="psc.employeeStatusToId != NEW_HIRE">
            <aims-fc>
              <div class="col-xs-5 text-right top10">
                <b>Exp Date:</b>
              </div>
              <div class="col-xs-7 top10">
                {{psc.cacExpDateFrom | date: 'MM/dd/yyyy'}}
              </div>
            </aims-fc>
          </ng-container>
          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <mat-form-field>
              <input name="Exp Date" matInput #aimsControl="ngModel" [matDatepicker]="picker11"
                [(ngModel)]="psc.cacExpDateTo" required>
              <mat-datepicker-toggle matSuffix [for]="picker11"></mat-datepicker-toggle>
              <mat-datepicker #picker11></mat-datepicker>
            </mat-form-field>
          </aims-fc>
          <ng-container *ngIf="psc.employeeStatusToId == NEW_HIRE">
            <aims-fc [isSpacer]="true"></aims-fc>
            <aims-fc [isSpacer]="true"></aims-fc>
          </ng-container>


        </aims-form>
      </aims-fc>
    </aims-form>
    <ng-container *ngIf="psc.pscTypeId == CAC">
      <br />
    </ng-container>



    <aims-form [spaceRows]="false" [cols]="1" [header]="'Comments'" [hider]="!(calculateEditable())">
      <div class="col-xs-12">
        <aims-common-table id="pscComments-table" [dataSource]="psc.hrPscComments" [header]="pscCommentHeader"
          [pageSize]="5" [permissions]="pscCommentTablePermissions"
          (rowUpdated)="handlePscCommentsTableRowUpdate($event)" (rowAdded)="handlePscCommentsTableRowAdd($event)"
          [addRowInitialObject]="pscCommentInitialTableElement">
        </aims-common-table>


      </div>
    </aims-form>

  </form>

</div>

<aims-spinner [spinnerText]="spinnerText" [showSpinner]="showSpinner"></aims-spinner>
